import Vue from 'vue'

export const commonMixin = {
    data () {
        let interInd = {
            agora: 0
        }
        let interPt = [
            'Agora'
        ]
        let interEn = [
            'Now'
        ]
        let interEs = [
            'Ahora'
        ]

        // auto increment inter keys list
        var count = 0
        for (var key in interInd) {
            interInd[key] = count
            count++
        }

        return {
            nome: 'commonMixin',

            // internacionalizacao
            inter_ind: interInd,
            inter_pt: interPt,
            inter_en: interEn,
            inter_es: interEs,
            user: {
                nome: '',
                email: '',
                fone: '',
                foto: '',
                pass: '',
                sucess: false,
                tipo: 0,
                idioma: 0,
                showMsg1: true,
                showMsg2: true,
                showMsg3: true,
                currentTab: 1
            },
            loading: {
                cats: false,
                estabs: false,
                commentaries: false,
                user: false,
                avaliacao: false,
                favorito: false,
                like: false,
                face: false,
                google: false
            },
            minSearchLen: 3,
            qMaxFotos: 5,
            cats_full: [
                {
                    id: 1,
                    nome: 'Joias',
                    imPath: 'brinco_ouro.jpg'
                },
                {
                    id: 2,
                    nome: 'Lançamentos',
                    imPath: 'brinco_esmeralda.jpg'
                },
                {
                    id: 3,
                    nome: 'Pérola',
                    imPath: 'brinco_ouro2.jpg'
                },
                {
                    id: 4,
                    nome: 'Casamento',
                    imPath: 'alianca_ouro.jpg'
                },
                {
                    id: 5,
                    nome: 'Infantil',
                    imPath: 'pulseira_prata.jpg'
                },
                {
                    id: 6,
                    nome: 'Masculino',
                    imPath: 'alianca_ouro.jpg'
                },
                {
                    id: 7,
                    nome: 'Relógios',
                    imPath: 'relogio_ouro.jpg'
                },
                {
                    id: 8,
                    nome: 'Namorados',
                    imPath: 'brinco_esmeralda.jpg'
                }
            ],
            tipo: [
                'Anel',
                'Brinco',
                'Colar',
                'Pingente',
                'Pulseira'
            ],
            material: [
                'Ouro Amarelo',
                'Ouro Branco',
                'Ouro Rosé',
                'Prata'
            ],
            pedras: [
                'Ametista',
                'Ametista Rosa',
                'Citrino',
                'Cristal',
                'Diamante',
                'Esmeralda',
                'Espinélio',
                'Granada',
                'Howlita turquesa',
                'Mix de Pedras',
                'Madrepérola',
                'Onix',
                'Peridoto',
                'Pérola',
                'Quartzo Fumê',
                'Quartzo Rosa',
                'Rubi',
                'Safira',
                'Topazio',
                'Turmalina',
                'Turquesa'
            ]
        }
    },

    components: {
    },

    watch: {
    },

    methods: {
        isMobile () {
            if (window.innerWidth < 861) {
                return true
            } else {
                return false
            }
        },
        getInterText (index) {
            switch (this.user.idioma) {
                case 1:
                    return this.inter_en[index]
                case 2:
                    return this.inter_es[index]
                default:
                    return this.inter_pt[index]
            }
        },
        getInterCatName (cat) {
            switch (this.user.idioma) {
                case 1:
                    return cat.nomeEn
                case 2:
                    return cat.nomeEs
                default:
                    return cat.nome
            }
        }
    },

    created () {
        console.log('commonMixin::created')

        Vue.prototype.$categoriaIndex2 = 0
    },

    mounted () {
        console.log('commonMixin::mounted')
    },

    beforeDestroy () {

    }
}



// WEBPACK FOOTER //
// ./src/scripts/commonMixin.js